'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPrimitive = require('../predicates/is-primitive.js');

const defaultConfig = {
    delimiter: {
        left: '{{',
        right: '}}',
    },
};
/**
 * Replace string inside a template. For now, only works with
 * an object containing promirives or array of primitives. If
 * it contains other objects, they will be ignored.
 *
 * Uses the mustache syntax by default.
 */
const replaceInTemplate = (template, params, config = defaultConfig) => {
    const { delimiter } = config;
    const leftDelimiter = typeof delimiter === 'string' ? delimiter : delimiter.left;
    const rightDelimiter = typeof delimiter === 'string' ? delimiter : delimiter.right;
    return Object
        .entries(params)
        .reduce((acc, [key, value]) => {
        if (!isPrimitive.isPrimitive(value) && !isPrimitive.isArrayOfPrimitive(value)) {
            return acc;
        }
        const searchValue = `${leftDelimiter}${key}${rightDelimiter}`;
        const replaceBy = Array.isArray(value) ? value.join(', ') : String(value);
        return acc.replace(searchValue, replaceBy);
    }, template);
};

exports.replaceInTemplate = replaceInTemplate;
//# sourceMappingURL=replace-in-template.js.map
